const SAVE_LEVEL = {
    CHAIN: 'chain',
    BRAND: 'brand',
    HOTEL: 'hotel',
    SYSTEM: 'system'
};

const SAVE_LEVEL_LABELS = {
    [SAVE_LEVEL.HOTEL]: 'Hotel',
    [SAVE_LEVEL.BRAND]: 'Brand',
    [SAVE_LEVEL.CHAIN]: 'Chain'
};

export { SAVE_LEVEL, SAVE_LEVEL_LABELS };



// WEBPACK FOOTER //
// ./src/constants/Level.js